var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramComplianceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10.6667H12.5003",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 14H10.317",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 5.50008H11.667C13.3337 5.50008 13.3337 4.66675 13.3337 3.83341C13.3337 2.16675 12.5003 2.16675 11.667 2.16675H8.33366C7.50033 2.16675 6.66699 2.16675 6.66699 3.83341C6.66699 5.50008 7.50033 5.50008 8.33366 5.50008Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.8501C16.1083 4.0001 17.5 5.0251 17.5 8.83343V13.8334C17.5 17.1668 16.6667 18.8334 12.5 18.8334H7.5C3.33333 18.8334 2.5 17.1668 2.5 13.8334V8.83343C2.5 5.03343 3.89167 4.0001 6.66667 3.8501",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramComplianceIcon);
export default __webpack_public_path__ + "static/media/program_compliance_icon.bb7ee3fe8743ff16251086f775ed8d24.svg";
export { ForwardRef as ReactComponent };